module.exports = __webpack_public_path__ + "static/media/printableRoj.b2296fc8.png";